import { AdditionalInfoDataMapper } from '@/data/persistences/mappers/AdditionalInfoDataMapper'
import { DependencyContainer } from 'tsyringe'
import { AuthDataMapper } from '@/data/persistences/mappers/AuthDataMapper'
import { UserDataMapper } from '@/data/persistences/mappers/UserDataMapper'
import { RoleDataMapper } from '@/data/persistences/mappers/RoleDataMapper'
import { DashboardDataMapper } from '@/data/persistences/mappers/DashboardDataMapper'
import { NotificationDataMapper } from '@/data/persistences/mappers/NotificationDataMapper'
import { HomebannerDataMapper } from '@/data/persistences/mappers/HomebannerDataMapper'
import { BulletinDataMapper } from '@/data/persistences/mappers/BulletinDataMapper'
import { FAQDataMapper } from '@/data/persistences/mappers/FAQDataMapper'
import { TrainingCategoryDataMapper } from '@/data/persistences/mappers/TrainingCategoryDataMapper'
import { GuideCategoryDataMapper } from '@/data/persistences/mappers/GuideCategoryDataMapper'
import { RecomendationDataMapper } from '@/data/persistences/mappers/RecomendationDataMapper'
import { TrainingMaterialDataMapper } from '@/data/persistences/mappers/TrainingMaterialDataMapper'
import { GuideMaterialDataMapper } from '@/data/persistences/mappers/GuideMaterialDataMapper'
import { GalleryImageDataMapper } from '@/data/persistences/mappers/GalleryImageDataMapper'
import { OtherContentDataMapper } from '@/data/persistences/mappers/OtherContentDataMapper'
import { PositionDataMapper } from '@/data/persistences/mappers/PositionDataMapper'
import { MasterCarDataMapper } from '@/data/persistences/mappers/MasterCarDataMapper'
import { MasterDataMapper } from '@/data/persistences/mappers/MasterDataMapper'
import { UserReportDataMapper } from '@/data/persistences/mappers/UserReportDataMapper'
import { AdminCMSMapper } from '@/data/persistences/mappers/AdminCMSMapper'
import { AdminCMSRoleDataMapper } from '@/data/persistences/mappers/AdminCMSRoleDataMapper'
import { BulletinReportDataMapper } from '@/data/persistences/mappers/BulletinReportDataMapper'
import { AdditionalInfoReportDataMapper } from '@/data/persistences/mappers/AdditionalInfoReportDataMapper'
import { TrainingMaterialReportDataMapper } from '@/data/persistences/mappers/TrainingMaterialReportDataMapper'
import { QuickGuideReportDataMapper } from '@/data/persistences/mappers/QuickGuideReportDataMappers'
import { NotificationReportDataMapper } from '@/data/persistences/mappers/NotificationReportDataMapper'

export class MapperModule {
  public static init(container: DependencyContainer) {
    container.register<AuthDataMapper>(AuthDataMapper, {
      useClass: AuthDataMapper,
    })
    container.register<UserDataMapper>(UserDataMapper, {
      useClass: UserDataMapper,
    })
    container.register<RoleDataMapper>(RoleDataMapper, {
      useClass: RoleDataMapper,
    })
    container.register<DashboardDataMapper>(DashboardDataMapper, {
      useClass: DashboardDataMapper,
    })
    container.register<NotificationDataMapper>(NotificationDataMapper, {
      useClass: NotificationDataMapper,
    })
    container.register<HomebannerDataMapper>(HomebannerDataMapper, {
      useClass: HomebannerDataMapper,
    })
    container.register<AdditionalInfoDataMapper>(AdditionalInfoDataMapper, {
      useClass: AdditionalInfoDataMapper,
    })
    container.register<BulletinDataMapper>(BulletinDataMapper, {
      useClass: BulletinDataMapper,
    })
    container.register<FAQDataMapper>(FAQDataMapper, {
      useClass: FAQDataMapper,
    })
    container.register<TrainingCategoryDataMapper>(TrainingCategoryDataMapper, {
      useClass: TrainingCategoryDataMapper,
    })
    container.register<GuideCategoryDataMapper>(GuideCategoryDataMapper, {
      useClass: GuideCategoryDataMapper,
    })
    container.register<RecomendationDataMapper>(RecomendationDataMapper, {
      useClass: RecomendationDataMapper,
    })
    container.register<TrainingMaterialDataMapper>(TrainingMaterialDataMapper, {
      useClass: TrainingMaterialDataMapper,
    })
    container.register<GuideMaterialDataMapper>(GuideMaterialDataMapper, {
      useClass: GuideMaterialDataMapper,
    })
    container.register<GalleryImageDataMapper>(GalleryImageDataMapper, {
      useClass: GalleryImageDataMapper,
    })
    container.register<OtherContentDataMapper>(OtherContentDataMapper, {
      useClass: OtherContentDataMapper,
    })
    container.register<PositionDataMapper>(PositionDataMapper, {
      useClass: PositionDataMapper,
    })
    container.register<MasterCarDataMapper>(MasterCarDataMapper, {
      useClass: MasterCarDataMapper,
    })
    container.register<MasterDataMapper>(MasterDataMapper, {
      useClass: MasterDataMapper,
    })
    container.register<UserReportDataMapper>(UserReportDataMapper, {
      useClass: UserReportDataMapper,
    })
    container.register<AdminCMSMapper>(AdminCMSMapper, {
      useClass: AdminCMSMapper,
    })
    container.register<AdminCMSRoleDataMapper>(AdminCMSRoleDataMapper, {
      useClass: AdminCMSRoleDataMapper,
    })
    container.register<BulletinReportDataMapper>(BulletinReportDataMapper, {
      useClass: BulletinReportDataMapper,
    })
    container.register<AdditionalInfoReportDataMapper>(
      AdditionalInfoReportDataMapper,
      {
        useClass: AdditionalInfoReportDataMapper,
      }
    )
    container.register<NotificationReportDataMapper>(
      NotificationReportDataMapper,
      {
        useClass: NotificationReportDataMapper,
      }
    )
    container.register<TrainingMaterialReportDataMapper>(
      TrainingMaterialReportDataMapper,
      {
        useClass: TrainingMaterialReportDataMapper,
      }
    )
    container.register<QuickGuideReportDataMapper>(QuickGuideReportDataMapper, {
      useClass: QuickGuideReportDataMapper,
    })
  }
}
